export {
  getGeneratedRoomName,
  getRoomDisplayName,
  type SearchOccupancy
} from './getRoomDisplayName'
export {useRoomDisplayName} from './useRoomDisplayName'
